"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    black: '#000000',
    white: '#ffffff',
    gray950: '#1F1F1F',
    gray900: '#303030',
    gray800: '#404040',
    gray700: '#525252',
    gray600: '#5E5E5E',
    gray500: '#666666',
    gray400: '#868686',
    gray300: '#999999',
    gray200: '#BFBFBF',
    gray100: '#DBDBDB',
    gray50: '#F0F0F0',
    gray10: '#FAFAFA',
    brandIndigo: '#031368',
    brandYellow: '#F6C042',
    brandPurple: '#8257DB',
    brandPink: '#F2CEFE',
    primary950: '#0A231E',
    primary900: '#632dd2',
    primary800: '#175447',
    primary700: '#8257DB',
    primary600: '#2EA88F',
    primary500: '#8B4FE3',
    primary400: '#61D4BB',
    primary300: '#80DCC9',
    primary200: '#A0E5D7',
    primary100: '#DCCAF7',
    primary50: '#F1EAFC',
    primary10: '#F0FFFC',
    blue950: '#03102D',
    blue900: '#031336',
    blue800: '#07266B',
    blue700: '#0A39A1',
    blue600: '#0D4CD6',
    blue500: '#2A69F2',
    blue400: '#4D82F4',
    blue300: '#719BF6',
    blue200: '#95B4F9',
    blue100: '#B8CDFB',
    blue50: '#DCE6FD',
    purple950: '#140B24',
    purple900: '#291748',
    purple800: '#3D226D',
    purple700: '#522E91',
    purple600: '#6639B5',
    purple500: '#7F55C9',
    purple400: '#9471D2',
    purple300: '#AA8EDB',
    purple200: '#BFAAE4',
    purple100: '#D4C6ED',
    purple50: '#EAE3F6',
    crimson950: '#230A0F',
    crimson900: '#46131E',
    crimson800: '#691D2D',
    crimson700: '#8C263C',
    crimson600: '#AF304B',
    crimson500: '#CB415E',
    crimson400: '#D46179',
    crimson300: '#DC8094',
    crimson200: '#E5A0AF',
    crimson100: '#EEC0C9',
    crimson50: '#F6DFE4',
    red950: '#E5A0AF',
    red900: '#4A0E05',
    red800: '#6E1607',
    red700: '#931D09',
    red600: '#B8240C',
    red500: '#DD2B0E',
    red400: '#F14427',
    red300: '#F46953',
    red200: '#F78F7E',
    red100: '#FAB4A9',
    red50: '#FCDAD4',
    red10: '#FEF3F1',
    orange950: '#1C1000',
    orange900: '#392000',
    orange800: '#563100',
    orange700: '#724100',
    orange600: '#8F5100',
    orange500: '#AB6100',
    orange400: '#E38100',
    orange300: '#FF9D1D',
    orange200: '#FFB656',
    orange100: '#FFCE8E',
    orange50: '#FFE7C7',
    orangeBrand: '#EC5344',
    green950: '#09160B',
    green900: '#112C17',
    green800: '#1A4222',
    green700: '#23582D',
    green600: '#2B6E39',
    green500: '#348444',
    green400: '#43AB58',
    green300: '#63C276',
    green200: '#8AD198',
    green100: '#B1E0BA',
    green50: '#D8F0DD',
    yellow100: '#FEF6E3',
};
//# sourceMappingURL=colors.js.map